import styled from "styled-components";
import { Button } from "@material-ui/core";
import theme from "@src/Tools/MuiTheme";

export const STRegenerateButton = styled(Button)`
  && {
    margin-top: ${theme.spacing(2)}px;
    align-self: center;
  }
`;

export const STWrapper = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin: 0 auto;
`;
